module.exports = __webpack_public_path__ + "img/daphne.fe7cd009.png";